import { PageHeader } from 'ui/pageHeader';
import { useTakeoverContext } from '../../contexts/Takeover';
import { useTranslations } from '../../hooks/useTranslations';
import { UploadButtonCombo, UploadComboConfig } from '../UploadButtonCombo';
import { useViewContext } from '../../contexts/ViewContext';

export const creativeHeaderTestIds = {
  header: 'cl-index-header',
  btnUpload: 'cl-index-upload-button',
};

export const CreativeLibraryHeader = () => {
  const { t } = useTranslations();
  const { hasManageBaseTemplatesPermission } = useViewContext();
  const { onNewFiles, onImportFromUrl } = useTakeoverContext();

  const uploadComboConfig: UploadComboConfig = {
    label: t('button.upload'),
    onClick: onNewFiles,
    actions: [
      {
        content: t('menu.linkRemote'),
        id: 'btn-combo-import-from-url',
        onClick: onImportFromUrl,
      },
    ],
  };

  return (
    <PageHeader
      documentTitle={t('header.creativeLibrary')}
      data-test={creativeHeaderTestIds.header}
      pageActions={
        hasManageBaseTemplatesPermission && <UploadButtonCombo config={uploadComboConfig} />
      }
    >
      <span>{t('header.creativeLibrary')}</span>
    </PageHeader>
  );
};
